function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import vent from 'elements/vent';
import $ from 'jquery';
export var pcsFormNote = new ( /*#__PURE__*/function () {
  function PcsFormNote() {
    var _this = this;
    _classCallCheck(this, PcsFormNote);
    vent.on('APP:READY', function (_) {
      _this.init();
    });
  }
  _createClass(PcsFormNote, [{
    key: "init",
    value: function init() {
      $(document).on('submit', '.pcs-form-note', this.onSubmitValues.bind(this));
    }
  }, {
    key: "onSubmitValues",
    value: function onSubmitValues(e) {
      e.preventDefault();
      vent.publish('PCS:SUBMIT_FORM', {
        form: $(e.target),
        successCallback: function successCallback(response) {},
        errorCallback: function errorCallback(response) {}
      });
    }
  }]);
  return PcsFormNote;
}())();